import { Container, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Paper from '../../components/Paper';
import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import CustomTable from '../../components/CustomTable';
import ConversationService from '../../services/conversation.service';
import tableColumnMetadata from './table.metadata';
import { BiExport } from 'react-icons/bi';

interface Message {
  creationDate: string;
  sendType: string;
  message: string;
}

const conversationService = new ConversationService();

export default function Conversation() {
  const params = useParams();
  const navigate = useNavigate();

  const [messages, setMessages] = useState<Message[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    pageCount: 1,
    totalCount: 1
  });
  const [loading, setLoading] = useState(false);
  const [conversationInfo, setConversationInfo] = useState({ customer: '', unit: '' });

  useEffect(() => {
    if (!params.conversationId) {
      console.error('Conversation ID not provided');
      navigate('/error');
      return;
    }

    const fetchMessages = async () => {
      setLoading(true);
      try {
        const response = await conversationService.listMessages(
          params.conversationId as string,
          pagination.pageSize,
          pagination.page
        );

        const formattedMessages = response.data.data.map((message: Message) => ({
          ...message,
          creationDate: format(new Date(message.creationDate), 'dd/MM/yyyy HH:mm')
        }));

        const responseConversation = await conversationService.getConversation(
          params.conversationId as string
        );
        console.log(responseConversation.data.data.customer, responseConversation.data.data.unit);

        setConversationInfo({
          customer: responseConversation.data.data.customer || 'Sin cliente',
          unit: responseConversation.data.data.unit || 'Sin unidad'
        });

        setMessages(formattedMessages);
        setPagination(response.data.pagination);
      } catch (error) {
        console.error('Error fetching messages:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [params.conversationId, pagination.page, pagination.pageSize, navigate]);

  const handleFooterClick = (value: number) => {
    setPagination({ ...pagination, page: pagination.page + value });
  };

  const handleExportClick = async () => {
    if (!params.conversationId) {
      console.error('Conversation ID is missing');
      return;
    }

    try {
      const response = await conversationService.exportMessages(params.conversationId);

      const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'mensajes_report.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting conversations:', error);
    }
  };

  return (
    <Container>
      <Paper>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>Cliente:</span>
            <span>{conversationInfo.customer}</span>
          </div>
          <div style={{ display: 'flex', gap: '5px' }}>
            <span style={{ fontWeight: 'bold' }}>Unidad:</span>
            <span>{conversationInfo.unit}</span>
          </div>
          <Button variant="outline-primary" onClick={handleExportClick}>
            <BiExport className="button-icon" />
            Exportar
          </Button>
        </div>

        {/* Tabla con las conversaciones */}
        <CustomTable
          data={messages}
          columnsMetadata={tableColumnMetadata}
          loading={loading}
          footerProps={{
            onClick: handleFooterClick,
            pagination,
            loading
          }}
        />
      </Paper>
    </Container>
  );
}
